import { forwardRef } from 'react';
import { cn } from '../../lib/utils';

/**
 * The 1–10 slider the dashboard's Daily Check-in uses.
 *
 * PARITY TODO: production uses the Radix slider, which draws its own track and
 * thumb. This is a native `input[type=range]` styled to the same palette — the
 * same control with the same range, step and value, rendered by the browser
 * rather than by a dependency V2 does not carry. It is also keyboard-operable
 * and announced without any work, which the Radix one needs props for.
 */
export type SliderProps = Omit<
  React.InputHTMLAttributes<HTMLInputElement>,
  'type' | 'value' | 'onChange'
> & {
  min: number;
  max: number;
  step: number;
  value: number;
  onValueChange: (value: number) => void;
};

export const Slider = forwardRef<HTMLInputElement, SliderProps>(
  ({ className, min, max, step, value, onValueChange, ...props }, ref) => (
    <input
      ref={ref}
      type="range"
      min={min}
      max={max}
      step={step}
      value={value}
      onChange={(event) => onValueChange(Number(event.target.value))}
      className={cn(
        'w-full cursor-pointer accent-primary',
        'focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring',
        className,
      )}
      {...props}
    />
  ),
);

Slider.displayName = 'Slider';
